import * as React from 'react';

export const MoreVertIcon: React.FunctionComponent = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
      <path
        d="M12 20.65q-.9 0-1.55-.65t-.65-1.55q0-.925.65-1.588.65-.662 1.55-.662.925 0 1.562.662.638.663.638 1.563 0 .925-.638 1.575-.637.65-1.562.65Zm0-6.45q-.9 0-1.55-.65T9.8 12q0-.925.65-1.562Q11.1 9.8 12 9.8q.925 0 1.562.638.638.637.638 1.562 0 .9-.638 1.55-.637.65-1.562.65Zm0-6.4q-.9 0-1.55-.663-.65-.662-.65-1.587 0-.9.65-1.55T12 3.35q.925 0 1.562.65.638.65.638 1.55 0 .925-.638 1.587Q12.925 7.8 12 7.8Z"
        fill="#919EAB"
      />
    </svg>
  );
};
